window.VH = window.VH === undefined ? {} : window.VH;
VH.OrderForm = {
    volumeField : null,
    volumeBase : null,
    weightField : null,
    weightBase : null,
    amountField : null,

    round : function round(number)
    {
        let perc = 10000;
        return Math.ceil(number * perc) / perc;
    },

    init : function init() {
        let _t = VH.OrderForm;

        _t.volumeField = $('#calc_product_volume');
        _t.volumeBase = parseFloat(_t.volumeField.data('base'));

        _t.weightField = $('#calc_product_weight');
        _t.weightBase = parseFloat(_t.weightField.data('base'));

        _t.amountField = $('#ofAmount');

        _t.amountField.on('change', function () {
            let amountVal = parseInt($(this).val());
            _t.volumeField.html(_t.round(_t.volumeBase * amountVal));
            _t.weightField.html(_t.round(_t.weightBase * amountVal));
        });
    }
};
